function addWorldwideFooterLinksIfNotUK(isUkCombined) {
  window.orb = window.orb || {};
  const worldwideFooterLinksHtml = window.orb.worldwideFooterlinks;
  if (isUkCombined === false && worldwideFooterLinksHtml) {
    // add worldwide advertisement links to the footer
    document
      .querySelector('#orb-contentinfo ul')
      .insertAdjacentHTML('beforeend', worldwideFooterLinksHtml);
  }
}

window.bbcuser
  .isUKCombined()
  .then(addWorldwideFooterLinksIfNotUK)
  .catch(() => {
    // default to uk if promise fails
    addWorldwideFooterLinksIfNotUK(true);
  });

if (document.documentElement.className.includes('b-reith-')) {
  import('./orbit/font-watcher.js').then((fontWatchModule) => {
    const watch = fontWatchModule.default;
    if (document.documentElement.className.includes('b-reith-sans-font')) {
      watch('ReithSans', 'b-reith-sans-loaded');
    }

    if (document.documentElement.className.includes('b-reith-serif-font')) {
      watch('ReithSans', 'b-reith-serif-loaded');
    }
  });
}
